<template>
<el-radio-group v-model="displayType" size="small" @change="onSelectChanged">
  <el-radio-button :label="2">图表</el-radio-button>
  <el-radio-button :label="1">列表</el-radio-button>
</el-radio-group>
</template>

<script>
export default {
  name: 'DisplayType',
  props: {
    defaultDisplayType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      displayType: this.defaultDisplayType
    }
  },
  methods: {
    onSelectChanged (displayType) {
      this.$emit('update:defaultDisplayType', displayType)
      this.$emit('change', displayType)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/DisplayType.vue